export const labels = {
    overview: "Übersicht",
    players: "Spieler",
    worlds: "Welten",
    layers: "Layers",
    locations: "Waypoints",
    tools: "Tools",
    settings: "Optionen",
};
export const stateLabel = (state) =>
    ({
        live: "Verbunden",
        connecting: "Verbinde …",
        reconnecting: "Verbinde neu …",
        offline: "Nicht verbunden",
        static: "Statische Karte",
    })[state] || "Nicht verfügbar";
export const worldLabel = (world) => world?.display_name || world?.name || "Unknown world";
